/* Deviria — capa de interacción. Todo el contenido está en el HTML; esto solo lo enriquece. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var WA = '34613146839';

  function safe(name, fn) {
    try { fn(); } catch (err) { if (window.console) console.warn('[deviria] ' + name, err); }
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function madridNow() {
    var parts = new Intl.DateTimeFormat('es-ES', { timeZone: 'Europe/Madrid', hour: '2-digit', minute: '2-digit', weekday: 'long', day: 'numeric', month: 'long', hour12: false }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return { hh: parseInt(o.hour, 10) % 24, mm: o.minute, time: (o.hour === '24' ? '00' : o.hour) + ':' + o.minute, weekday: o.weekday, day: o.day, month: o.month };
  }

  /* ---------- menú móvil ---------- */
  safe('menu', function () {
    var menu = $('[data-menu]'), open = $('[data-menu-open]'), close = $('[data-menu-close]');
    if (!menu || !open) return;
    function set(state) {
      menu.hidden = !state;
      menu.classList.toggle('is-open', state);
      open.setAttribute('aria-expanded', String(state));
      document.body.style.overflow = state ? 'hidden' : '';
      if (state) { var first = $('a', menu); if (first) first.focus(); } else open.focus();
    }
    open.addEventListener('click', function () { set(true); });
    close.addEventListener('click', function () { set(false); });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) set(false); });
  });

  /* ---------- barra: se aparta al bajar, vuelve al subir ---------- */
  safe('bar', function () {
    var bar = $('[data-bar]');
    if (!bar) return;
    var last = window.scrollY, queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        var y = window.scrollY;
        bar.classList.toggle('is-hidden', y > 480 && y > last + 4);
        if (y < last - 4 || y < 480) bar.classList.remove('is-hidden');
        last = y;
      });
    }, { passive: true });
    bar.addEventListener('focusin', function () { bar.classList.remove('is-hidden'); });
  });

  /* ---------- reloj real de Ciudad Real ---------- */
  safe('clock', function () {
    var el = $('[data-clock]');
    if (!el) return;
    function tick() { el.textContent = 'Son las ' + madridNow().time; }
    tick();
    setInterval(tick, 15000);
  });

  /* ---------- entradas al hacer scroll ---------- */
  safe('reveal', function () {
    var els = $$('[data-reveal], [data-shutter]');
    if (!('IntersectionObserver' in window) || reduced) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
    els.forEach(function (el) { io.observe(el); });
    // red de seguridad: lo que ya ha pasado por encima (un salto desde el menú) se muestra siempre
    var queued = false;
    function sweep() {
      queued = false;
      els = els.filter(function (el) {
        if (el.getBoundingClientRect().top < innerHeight * 0.92) { el.classList.add('is-in'); io.unobserve(el); return false; }
        return true;
      });
      if (!els.length) window.removeEventListener('scroll', onScroll);
    }
    function onScroll() { if (!queued) { queued = true; requestAnimationFrame(sweep); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(sweep, 2500);
  });

  /* ---------- frases que suben línea a línea ---------- */
  safe('lines', function () {
    var els = $$('[data-lines]');
    if (!els.length || !('IntersectionObserver' in window) || reduced) return;
    function restore(el) { el.textContent = el.dataset.text; el.classList.remove('is-split', 'is-in'); }
    function split(el) {
      var text = el.textContent.trim().replace(/\s+/g, ' ');
      el.dataset.text = text;
      el.textContent = '';
      var words = text.split(' ').map(function (word) {
        var s = document.createElement('span');
        s.style.display = 'inline-block';
        s.textContent = word;
        el.append(s, ' ');
        return s;
      });
      var lines = [];
      words.forEach(function (w) {
        var lastLine = lines[lines.length - 1];
        if (lastLine && Math.abs(lastLine.top - w.offsetTop) < 4) lastLine.words.push(w.textContent);
        else lines.push({ top: w.offsetTop, words: [w.textContent] });
      });
      el.textContent = '';
      lines.forEach(function (line, i) {
        var mask = document.createElement('span'), inner = document.createElement('span');
        mask.className = 'line';
        inner.style.setProperty('--i', i);
        inner.textContent = line.words.join(' ');
        mask.append(inner);
        el.append(mask, ' ');
      });
      el.classList.add('is-split');
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.classList.add('is-in');
        var lastSpan = e.target.querySelector('.line:last-of-type > span');
        if (lastSpan) lastSpan.addEventListener('transitionend', function () { restore(e.target); }, { once: true });
        else restore(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    document.fonts.ready.then(function () {
      els.forEach(function (el) {
        if (el.getBoundingClientRect().bottom < 0) return; // ya leído: se queda como texto normal
        split(el); io.observe(el);
      });
    });
    window.addEventListener('scroll', function () {
      els.forEach(function (el) { if (el.matches('.is-split:not(.is-in)') && el.getBoundingClientRect().bottom < 0) { io.unobserve(el); restore(el); } });
    }, { passive: true });
    var width = innerWidth;
    window.addEventListener('resize', function () {
      if (innerWidth === width) return;
      width = innerWidth;
      els.filter(function (el) { return el.matches('.is-split:not(.is-in)'); }).forEach(function (el) { io.unobserve(el); restore(el); });
    });
  });

  /* ---------- las cinco frases: se enciende la que está en el centro ---------- */
  safe('quotes', function () {
    var items = $$('[data-quotes] .quote');
    if (!items.length || !('IntersectionObserver' in window)) return;
    function show(i) { items.forEach(function (el, k) { el.classList.toggle('is-active', k === i); }); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) show(items.indexOf(e.target)); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    items.forEach(function (el) { io.observe(el); });
    show(0);
  });

  /* ---------- reels: suenan en silencio solo cuando se ven ---------- */
  safe('videos', function () {
    var vids = $$('video[data-autoplay]');
    if (reduced || !('IntersectionObserver' in window)) { vids.forEach(function (v) { v.controls = true; }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () { v.controls = true; }); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  });

  /* ---------- la demo: el asistente contesta a la hora real ---------- */
  safe('demo', function () {
    var chat = $('[data-chat]');
    if (!chat) return;
    var log = $('[data-chat-log]', chat), nameEl = $('[data-chat-name]', chat), timeEl = $('[data-chat-time]', chat);
    var bizBtns = $$('[data-biz] .chip'), askBtns = $$('[data-asks] .ask');

    var BIZ = {
      peluqueria: { name: 'Peluquería Lúa', owner: 'Lúa', open: [[9.5, 14], [16.5, 20]], sat: [9.5, 14],
        hours: 'Abrimos de lunes a viernes de 9:30 a 14:00 y de 16:30 a 20:00, y el sábado de 9:30 a 14:00.',
        price: 'Un corte son 15 €, y con lavado y peinado, 22 €. El tinte depende del largo: te lo dicen en el momento.',
        hueco: '¿Tenéis hueco el sábado?', what: 'corte y peinado', slots: ['10:00', '11:30', '12:15'] },
      clinica: { name: 'Clínica Sana', owner: 'la clínica', open: [[9, 14], [16, 20]], sat: [10, 13],
        hours: 'Atendemos de lunes a viernes de 9:00 a 14:00 y de 16:00 a 20:00, y el sábado de 10:00 a 13:00.',
        price: 'La primera valoración es gratuita. Después, cada tratamiento tiene su precio y te lo explican en esa visita.',
        hueco: '¿Tenéis hueco el sábado?', what: 'primera valoración', slots: ['10:00', '11:00', '12:30'] },
      taller: { name: 'Talleres Molina', owner: 'Ricardo', open: [[8, 13.5], [15.5, 19]], sat: [9, 13],
        hours: 'Abrimos de lunes a viernes de 8:00 a 13:30 y de 15:30 a 19:00, y el sábado por la mañana de 9:00 a 13:00.',
        price: 'El cambio de aceite con filtro está desde 59 €. Para otra reparación, te doy cita y Ricardo te da presupuesto sin compromiso.',
        hueco: '¿Puedo llevar el coche el sábado?', what: 'revisión del coche', slots: ['9:00', '10:30', '12:00'] },
      bar: { name: 'Bar La Plaza', owner: 'Juan', open: [[8, 16], [19.5, 24]], sat: [9, 24],
        hours: 'Abrimos todos los días de 8:00 a 16:00 y por la noche de 19:30 a 0:00. El sábado, sin cerrar desde las 9:00.',
        price: 'El menú del día son 13 €, con primero, segundo, postre y bebida. Por la noche hay raciones y tapas.',
        hueco: '¿Tenéis mesa el sábado?', what: 'mesa para 4', slots: ['13:30', '14:30', '21:00'] }
    };
    var biz = 'peluqueria', busy = false, runId = 0;

    function isOpen(b) {
      var n = madridNow(), h = n.hh + parseInt(n.mm, 10) / 60;
      if (n.weekday === 'domingo') return false;
      var spans = n.weekday === 'sábado' ? [b.sat] : b.open;
      return spans.some(function (s) { return h >= s[0] && h < s[1]; });
    }
    function saturdayLabel() {
      var n = madridNow();
      var days = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];
      var idx = days.indexOf(n.weekday);
      var add = idx === 5 ? 7 : (5 - idx + 7) % 7;
      var d = new Date(Date.now() + add * 864e5);
      var day = new Intl.DateTimeFormat('es-ES', { timeZone: 'Europe/Madrid', day: 'numeric', month: 'long' }).format(d);
      return (idx === 5 ? 'el sábado que viene, ' : 'este sábado, ') + day;
    }
    function clock() { timeEl.textContent = madridNow().time; }
    function wait(ms) { return new Promise(function (r) { setTimeout(r, reduced ? Math.min(ms, 150) : ms); }); }
    function add(cls, text) {
      var p = document.createElement('p');
      p.className = 'msg ' + cls;
      p.textContent = text;
      log.append(p);
      while (log.children.length > 9) log.firstElementChild.remove();
      return p;
    }
    function botSays(text, id) {
      var dots = document.createElement('p');
      dots.className = 'msg msg--bot msg--dots';
      dots.setAttribute('aria-label', 'Escribiendo');
      dots.innerHTML = '<i></i><i></i><i></i>';
      log.append(dots);
      return wait(700 + Math.min(text.length * 12, 900)).then(function () {
        dots.remove();
        if (id === runId) add('msg--bot', text);
      });
    }
    function card(title, text) {
      var d = document.createElement('div');
      d.className = 'booked msg';
      d.innerHTML = '<svg width="28" height="28" viewBox="0 0 28 28" aria-hidden="true"><circle cx="14" cy="14" r="14" fill="#4ADE9C"/><path d="M8 14.5l4 4 8-8.5" fill="none" stroke="#0A0714" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg><span><b></b></span>';
      d.querySelector('b').textContent = title;
      d.querySelector('span').append(text);
      log.append(d);
    }
    function lock(state) { busy = state; askBtns.forEach(function (b) { b.disabled = state; }); }

    function greet() {
      runId++;
      var b = BIZ[biz];
      log.textContent = '';
      nameEl.textContent = 'Asistente de ' + b.name;
      var greeting = isOpen(b)
        ? 'Hola, soy el asistente de ' + b.name + '. ' + b.owner.charAt(0).toUpperCase() + b.owner.slice(1) + ' está atendiendo, pero yo te contesto ya. ¿En qué te ayudo?'
        : 'Hola, son las ' + madridNow().time + ' y ' + b.name + ' está cerrado, pero yo sigo aquí. ¿En qué te ayudo? Puedo darte cita ahora mismo.';
      add('msg--bot', greeting);
      askBtns.forEach(function (btn) { if (btn.dataset.ask === 'hueco') btn.textContent = b.hueco; });
      lock(false);
    }

    function run(kind, label, isAuto) {
      if (busy) return;
      lock(true);
      var id = ++runId, b = BIZ[biz];
      add('msg--me', label);
      var flow;
      if (kind === 'hueco') {
        flow = botSays('Sí, ' + saturdayLabel() + ', tengo estos huecos para ' + b.what + '. ¿Cuál te viene mejor?', id).then(function () {
          if (id !== runId) return;
          var row = document.createElement('div');
          row.className = 'chips msg';
          b.slots.forEach(function (s) {
            var btn = document.createElement('button');
            btn.type = 'button'; btn.className = 'chip'; btn.textContent = s;
            btn.addEventListener('click', function () {
              row.remove();
              add('msg--me', 'A las ' + s + ', por favor');
              botSays('Hecho. Te he apuntado y te llegará un recordatorio el día antes.', id).then(function () {
                if (id !== runId) return;
                card('Cita confirmada', saturdayLabel().replace(/^(este|el) sábado( que viene)?, /, 'Sábado ') + ' · ' + s + ' · ' + b.name);
                lock(false);
              });
            });
            row.append(btn);
          });
          log.append(row);
          var firstSlot = row.querySelector('button'); if (firstSlot && finePointer && !isAuto) firstSlot.focus({ preventScroll: true });
        });
        return;
      }
      if (kind === 'horario') flow = botSays(b.hours + ' ¿Quieres que te busque un hueco?', id);
      if (kind === 'precio') flow = botSays(b.price, id);
      if (kind === 'humano') flow = botSays('Entendido. Eso prefiero que lo veas con ' + b.owner + ' en persona: le acabo de pasar tu mensaje y te escribe en cuanto pueda.', id).then(function () {
        if (id === runId) card('Aviso enviado', 'Le ha llegado tu mensaje a ' + b.owner + '. Si no sé algo, no me lo invento.');
      });
      flow.then(function () { if (id === runId) lock(false); });
    }

    bizBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        bizBtns.forEach(function (o) { o.setAttribute('aria-pressed', String(o === btn)); });
        biz = btn.dataset.value;
        greet();
      });
    });
    askBtns.forEach(function (btn) { btn.addEventListener('click', function () { run(btn.dataset.ask, btn.textContent); }); });
    clock();
    setInterval(clock, 15000);
    greet();
    // la primera vez que se ve, el cliente de ejemplo pregunta solo
    if ('IntersectionObserver' in window) {
      var auto = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        auto.disconnect();
        setTimeout(function () { if (!busy && log.children.length === 1) run('hueco', askBtns[0].textContent, true); }, 500);
      }, { threshold: 0.5 });
      auto.observe(chat);
    }
  });

  /* ---------- formulario: en Shopify lo envía la tienda; en la versión estática abre WhatsApp ---------- */
  safe('form', function () {
    var form = $('[data-lead]');
    if (!form) return;
    var err = $('[data-form-error]', form);
    var sentOk = $('.form__ok:not([hidden])', form);
    if (sentOk) sentOk.focus(); // vuelta de Shopify tras enviar
    form.addEventListener('submit', function (e) {
      var fields = $$('label input', form);
      var bad = fields.filter(function (f) {
        if (!f.required) return false;
        if (f.type === 'checkbox') return !f.checked;
        return !f.value.trim() || (f.type === 'email' && !/^\S+@\S+\.\S+$/.test(f.value));
      });
      fields.forEach(function (f) { f.setAttribute('aria-invalid', String(bad.indexOf(f) > -1)); });
      if (bad.length) { e.preventDefault(); err.hidden = false; bad[0].focus(); return; }
      err.hidden = true;
      if (form.hasAttribute('action')) return; // formulario de contacto de Shopify: se envía tal cual
      e.preventDefault();
      // cada campo rellenado va al mensaje con el nombre de su etiqueta
      var text = 'Hola Marcos, quiero el diagnóstico gratis.' + fields.filter(function (f) {
        return f.type === 'checkbox' ? f.name === 'novedades' && f.checked : f.value.trim();
      }).map(function (f) {
        if (f.type === 'checkbox') return '\nQuiero recibir novedades y ofertas: sí';
        var label = f.closest('label').querySelector('span').textContent.replace(/\*|\(opcional\)/g, '').trim();
        return '\n' + label + ': ' + f.value.trim();
      }).join('');
      var url = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(text);
      var win = window.open(url, '_blank', 'noopener');
      if (!win) { window.location.href = url; return; } // si el navegador bloquea la pestaña nueva, va en esta
      ok.hidden = false;
      ok.focus();
    });
    var ok = $('[data-form-ok]', form);
  });

  /* ---------- banner de cookies propio, guardado con la Customer Privacy API de Shopify ---------- */
  safe('cookies', function () {
    var KEY = 'deviria-cookies';
    var CATS = [
      ['preferences', 'Preferencias', 'Recuerdan ajustes como el idioma.'],
      ['analytics', 'Estadísticas', 'Cuentan las visitas, sin saber quién eres, para ver qué páginas sirven y cuáles no.'],
      ['marketing', 'Marketing', 'Miden si los anuncios funcionan y permiten enseñarte anuncios de Deviria en otras webs.']
    ];
    var policy = window.Shopify ? '/pages/politica-de-cookies' : 'https://deviria.es/pages/politica-de-cookies';
    var api = null, box = null, prefs, toggleBtn;

    function stored() { try { return JSON.parse(window.localStorage.getItem(KEY)); } catch (e) { return null; } }
    function current() {
      if (api) {
        var c = api.currentVisitorConsent() || {};
        if (!c.marketing && !c.analytics && !c.preferences) return null; // '' = todavía no ha decidido
        return { preferences: c.preferences === 'yes', analytics: c.analytics === 'yes', marketing: c.marketing === 'yes' };
      }
      return stored();
    }
    function save(c) {
      try { window.localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
      if (api) api.setTrackingConsent({ preferences: c.preferences, analytics: c.analytics, marketing: c.marketing, sale_of_data: c.marketing }, function () {});
      hide();
    }
    function all(v) { return { preferences: v, analytics: v, marketing: v }; }

    function build() {
      box = document.createElement('section');
      box.className = 'cookies';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'false');
      box.setAttribute('aria-labelledby', 'cookies-title');
      box.hidden = true;
      box.innerHTML =
        '<p class="cookies__dots" aria-hidden="true"><i></i><i></i><i></i></p>' +
        '<h2 class="cookies__title" id="cookies-title">Cookies, las justas</h2>' +
        '<p class="cookies__text">Las necesarias hacen que la web funcione. Las demás solo se activan si tú quieres. <a href="' + policy + '">Política de cookies</a></p>' +
        '<div class="cookies__prefs" id="cookies-prefs" hidden>' +
          '<div class="cookies__row"><div><strong>Necesarias</strong><span>Hacen que la web funcione y recuerdan lo que eliges aquí.</span></div><em>Siempre activas</em></div>' +
          CATS.map(function (c) {
            return '<label class="cookies__row"><div><strong>' + c[1] + '</strong><span>' + c[2] + '</span></div>' +
              '<input type="checkbox" role="switch" class="cookies__switch" name="' + c[0] + '"></label>';
          }).join('') +
        '</div>' +
        '<div class="cookies__actions">' +
          '<button type="button" class="cookies__link" data-c="config" aria-expanded="false" aria-controls="cookies-prefs">Configurar</button>' +
          '<button type="button" class="cookies__btn" data-c="reject">Rechazar</button>' +
          '<button type="button" class="cookies__btn" data-c="accept">Aceptar todas</button>' +
        '</div>';
      document.body.insertBefore(box, document.body.firstChild);
      prefs = $('.cookies__prefs', box);
      toggleBtn = $('[data-c="config"]', box);
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-c]');
        if (!b) return;
        var act = b.getAttribute('data-c');
        if (act === 'accept') save(all(true));
        else if (act === 'reject') save(all(false));
        else if (prefs.hidden) openPrefs();
        else {
          var c = {};
          CATS.forEach(function (k) { c[k[0]] = $('[name="' + k[0] + '"]', box).checked; });
          save(c);
        }
      });
    }
    function openPrefs() {
      prefs.hidden = false;
      box.classList.add('is-prefs');
      toggleBtn.textContent = 'Guardar selección';
      toggleBtn.setAttribute('aria-expanded', 'true');
    }
    function show(withPrefs) {
      if (!box) build();
      var c = current() || all(false);
      CATS.forEach(function (k) { $('[name="' + k[0] + '"]', box).checked = !!c[k[0]]; });
      if (withPrefs) openPrefs();
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-in'); });
      if (withPrefs) $('.cookies__switch', box).focus();
    }
    function hide() {
      box.classList.remove('is-in');
      setTimeout(function () { box.hidden = true; }, reduced ? 0 : 220);
    }

    function start() { if (!current()) show(false); }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err && window.Shopify.customerPrivacy) api = window.Shopify.customerPrivacy;
        start();
      });
    } else start();

    $$('[data-cookie-prefs]').forEach(function (btn) {
      btn.addEventListener('click', function () { show(true); });
    });
  });

  /* ---------- SEO local: la búsqueda que hace tu cliente, escribiéndose ---------- */
  safe('typewords', function () {
    var el = $('[data-type-words]');
    if (!el || reduced) return;
    var words = el.dataset.typeWords.split('|'), w = 0, i = words[0].length, deleting = true, timer = 0;
    function step() {
      var word = words[w];
      if (deleting) {
        i--;
        if (i <= 0) { deleting = false; w = (w + 1) % words.length; }
      } else {
        i++;
        if (i >= words[w].length) { el.textContent = words[w]; deleting = true; timer = setTimeout(step, 2200); return; }
      }
      el.textContent = (deleting ? word : words[w]).slice(0, Math.max(0, i));
      timer = setTimeout(step, deleting ? 35 : 70);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        clearTimeout(timer);
        if (entries[0].isIntersecting) timer = setTimeout(step, 1600);
      }).observe(el);
    }
  });

  /* ---------- Programa Fundador: días que quedan de verdad ---------- */
  safe('deadline', function () {
    var el = $('[data-deadline]');
    if (!el) return;
    var days = Math.ceil((new Date(el.dataset.deadline) - Date.now()) / 864e5);
    if (days > 1) el.textContent = 'Quedan ' + days + ' días: hasta el 30 de noviembre.';
    else if (days === 1) el.textContent = 'Queda el último día: hoy, 30 de noviembre.';
    else el.textContent = 'El plazo terminó el 30 de noviembre.';
  });

  /* ---------- los tres puntos del logo, en 3D, escribiendo ---------- */
  function dots3d() {
    var canvas = $('[data-dots]'), bubble = $('[data-typing]');
    if (!canvas || !bubble || !window.THREE) return;
    var THREE = window.THREE, renderer;
    try { renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true }); } catch (e) { return; }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.outputEncoding = THREE.sRGBEncoding;
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(30, 1, 0.1, 50);
    camera.position.set(0, 0, 10);

    scene.add(new THREE.HemisphereLight(0xc9c3ff, 0x1b1630, 0.9));
    var key = new THREE.DirectionalLight(0xffffff, 1.2); key.position.set(3, 4, 6); scene.add(key);
    var rim = new THREE.PointLight(0xff6b4d, 1.4, 30); rim.position.set(-5, -2, 2); scene.add(rim);
    var follow = new THREE.PointLight(0xffffff, 0.9, 20); follow.position.set(0, 0, 5); scene.add(follow);

    var colors = ['#2F6FFF', '#7B3FE4', '#B23CF0'];
    var group = new THREE.Group(); scene.add(group);
    var balls = colors.map(function (c) {
      var col = new THREE.Color(c).convertSRGBToLinear();
      var m = new THREE.Mesh(new THREE.SphereGeometry(1, 48, 48), new THREE.MeshPhysicalMaterial({ color: col, roughness: 0.22, metalness: 0.05, clearcoat: 1, clearcoatRoughness: 0.08, emissive: col, emissiveIntensity: 0.12 }));
      group.add(m);
      return m;
    });

    // del logo (dos arriba, uno abajo) a la fila del "escribiendo…"
    var logoPos = [[-0.55, 0.28], [0.35, 0.42], [0.05, -0.5]], rowPos = [[-1, 0], [0, 0], [1, 0]];
    var unitW = 1, unitH = 1, radius = 0.4, morph = reduced ? 1 : 0, start = performance.now();
    var mouse = { x: 0, y: 0 }, eased = { x: 0, y: 0 }, typing = 1, typingTarget = 1, visible = true, raf = 0;

    function size() {
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      unitH = 2 * camera.position.z * Math.tan(THREE.MathUtils.degToRad(camera.fov / 2));
      unitW = unitH * camera.aspect;
      radius = unitH * 0.105;
      balls.forEach(function (b) { b.scale.setScalar(radius); });
    }

    var prev = start;
    function render(now) {
      raf = 0;
      var t = (now - start) / 1000, f = Math.min(4, (now - prev) / 16.67);
      prev = now;
      if (!reduced) morph = Math.min(1, Math.max(0, (t - 0.9) / 0.9));
      var k = morph < 0.5 ? 4 * morph * morph * morph : 1 - Math.pow(-2 * morph + 2, 3) / 2;
      var follow1 = 1 - Math.pow(0.93, f), follow2 = 1 - Math.pow(0.95, f);
      eased.x += (mouse.x - eased.x) * follow1; eased.y += (mouse.y - eased.y) * follow1;
      typing += (typingTarget - typing) * follow2;
      var spread = unitW * 0.19;
      balls.forEach(function (b, i) {
        var lx = logoPos[i][0] * spread * 0.9, ly = logoPos[i][1] * spread * 0.9;
        var rx = rowPos[i][0] * spread, ry = 0;
        var wave = reduced ? 0 : Math.pow(Math.max(0, Math.sin(t * 5.2 - i * 0.85)), 2) * radius * 0.85 * k * typing;
        b.position.x = lx + (rx - lx) * k + eased.x * radius * 0.35;
        b.position.y = ly + (ry - ly) * k + wave + eased.y * radius * 0.25;
        b.position.z = Math.sin(t * 1.3 + i) * radius * 0.2 * (reduced ? 0 : 1);
      });
      group.rotation.y = eased.x * 0.35;
      group.rotation.x = -eased.y * 0.25;
      follow.position.set(eased.x * 6, eased.y * 4, 5);
      renderer.render(scene, camera);
      if (!reduced && visible) raf = requestAnimationFrame(render);
    }
    function kick() { if (!raf) { prev = performance.now(); raf = requestAnimationFrame(render); } }

    window.addEventListener('pointermove', function (e) {
      var r = bubble.getBoundingClientRect();
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      mouse.x = Math.max(-1, Math.min(1, (e.clientX - cx) / (innerWidth * 0.45)));
      mouse.y = Math.max(-1, Math.min(1, -(e.clientY - cy) / (innerHeight * 0.45)));
      if (reduced) kick();
    }, { passive: true });
    bubble.addEventListener('pointerenter', function () { typingTarget = 1.6; });
    bubble.addEventListener('pointerleave', function () { typingTarget = 1; });
    document.addEventListener('visibilitychange', function () { visible = !document.hidden; if (visible) kick(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting && !document.hidden; if (visible) kick(); }).observe(bubble);
    }
    if ('ResizeObserver' in window) new ResizeObserver(function () { size(); kick(); }).observe(canvas);
    size();
    bubble.classList.add('has-3d');
    kick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { safe('dots3d', dots3d); });
  else safe('dots3d', dots3d);
})();
